import { createSelector } from "@reduxjs/toolkit";
import { useParams } from "react-router";
import { useSelector } from "react-redux";
import { RootState } from "./state/configureStore";

const useParamsSelector = <T>(selector: (s: RootState, p: { [key: string]: string | undefined }) => T) => {
  const params = useParams();
  return useSelector<RootState, T>(s => selector(s, params));
};
const getAssignmentId = (_state: RootState, params: { assignmentId?: string }) => params.assignmentId;

const getAssignments = (state: RootState) => state.teacherState.assignments;
export const getAssignment = createSelector(
  [getAssignments, getAssignmentId],
  (assignments, id = "") => assignments[id],
);

const getAssignmentClasses = (state: RootState) => state.teacherState.assignmentClasses;
export const getAssignmentClass = createSelector(
  [getAssignmentClasses, getAssignmentId],
  (assignmentClasses, id = "") => assignmentClasses[id],
);

const getStudentId = (_state: RootState, params: { studentId?: string }) => params.studentId;
const getStudents = (state: RootState) => state.teacherState.students;
export const getStudent = createSelector([getStudents, getStudentId], (students, id = "") => students[id]);

export default useParamsSelector;
